<div
  [ngClass]="{
    'multi-select-field': true,
    'multi-select-field--auto-validate': control,
    'multi-select-field--valid': valid,
    'multi-select-field--invalid': invalid,
    'multi-select-field--disabled': disabled,
  }"
>
  @if (label) {
    <label class="form-label" [htmlFor]="id">{{ label }}</label>
  }

  <div class="form-control-container">
    <p-multiselect
      [id]="id"
      [readonly]="readonly || disabled"
      [options]="mock"
      [(ngModel)]="selectedItems"
      [loading]="loading"
      placeholder="{{ placeholder }}"
      optionLabel="name"
      display="chip"
    />
  </div>

  @if (control && control.errors && control.touched) {
    <cx-form-errors [control]="control" />
  } @else if (hintText) {
    <span class="form-hint-text">{{ hintText }}</span>
  }
</div>
